import { SUPPORTED_LANGUAGES } from "../../localization/languages";

/**
 * The language a visitor picked in the portal header. i18next caches every
 * language it starts with, so its own key cannot tell a choice from a guess;
 * this key is written only by an explicit pick.
 */
export const PORTAL_LANGUAGE_CHOICE_KEY = "portal.languageChoice";

export const rememberPortalLanguageChoice = (languageCode: string): void => {
  try {
    localStorage.setItem(PORTAL_LANGUAGE_CHOICE_KEY, languageCode);
  } catch (error) {
    console.warn("Failed to store the portal language choice:", error);
  }
};

export const readPortalLanguageChoice = (): string | null => {
  try {
    return localStorage.getItem(PORTAL_LANGUAGE_CHOICE_KEY);
  } catch {
    return null;
  }
};

const toBaseLanguage = (language: string | null | undefined): string =>
  (language ?? "").toLowerCase().split("-")[0];

/**
 * The language the portal should switch to once the member is known, or null
 * to stay: a stored choice wins; otherwise the member's own language, when the
 * app supports it and is not already showing it.
 */
export const pickPortalLanguage = (
  memberLanguage: string | null | undefined,
  currentLanguage: string | null | undefined,
  storedChoice: string | null
): string | null => {
  if (storedChoice) return null;
  const target = toBaseLanguage(memberLanguage);
  if (!SUPPORTED_LANGUAGES.includes(target)) return null;
  return target === toBaseLanguage(currentLanguage) ? null : target;
};
